"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterInspirationTiles = void 0;
const filterInspirationTiles = items => items.filter(item => !!item.title && !!item.url);
exports.filterInspirationTiles = filterInspirationTiles;
